import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[puiTemplate]'
})
export class PuiTemplateDirective {
  @Input('puiTemplate') name: string;

  constructor(public template: TemplateRef<any>) {}
}

export function coerceBooleanProperty(value: any): boolean {
  return !!value && `${value}` !== 'false';
}

export function coerceSizeStyle(x: any): string {
  return isNaN(x) ? x : (x < 1 ? 100 * x + '%' : x + 'px');
}

export function arrayLikeEqual(a1: any, a2: any, delimiter = ','): boolean {
  let x = a1 instanceof Array ? a1.join(delimiter).split(delimiter) : (a1 ? a1.split(delimiter) : []);
  let y = a2 instanceof Array ? a2.join(delimiter).split(delimiter) : (a2 ? a2.split(delimiter) : []);
  return x.filter((i: any) => {
    let idx = y.indexOf(i);
    if (idx < 0) {
      return true;
    } else {
      y.splice(idx, 1);
      return false;
    }
  }).length === 0 && y.filter((i: any) => x.indexOf(i) < 0).length === 0;
}
